<template>
  <v-container>
    <label-table v-bind="props" :update-route="true"></label-table>
  </v-container>
</template>
<script>

import LabelTable from '@/components/LabelTable'
import {labelTable} from '@/tables'

export default {
  components: {
    LabelTable
  },
  data () {
    return {
      props: labelTable
    }
  }
}
</script>